export const ALL_COUNTRIES = ["US", "GB", "ID", "VN", "TH", "MY", "PH", "SG", "MX", "DE", "FR", "IT", "ES", "JP", "BR"];

export const DEFAULT_COUNTRY = "US";
export const DEFAULT_CURRENCY = "USD";

export const LOCALSTORAGE_KEY = {
  REGION: "region",
  CURRENCY: "currency",
  LANGUAGE: "language",
};

// 新开国家涉及配置
export const CURRENCY_SYMBOL: { [key: string]: string } = {
  CNY: "￥",
  USD: "$",
  IDR: "Rp",
  THB: "฿",
  MYR: "RM",
  VND: "₫",
  PHP: "₱",
  GBP: "£",
  SGD: "S$",
  MXN: "M$",
  EUR: "€",
  JPY: "円",
  BRL: "R$",
};

//  Pricing 页面国家映射货币
export const REGION_TO_CURRENCY: { [key: string]: string | string[] } = {
  Global: "CNY",
  "Southeast Asia": "CNY",
  Ameu: ["EUR", "GBP"],
  ID: "IDR",
  MY: "MYR",
  TH: "THB",
  VN: "VND",
  PH: "PHP",
  GB: "GBP",
  SG: "SGD",
  MX: "MXN",
  DE: "EUR",
  FR: "EUR",
  IT: "EUR",
  ES: "EUR",
  JP: "JPY",
  CN: "CNY",
  BR: "BRL",
};

export const BizCountry_TO_HowKnownKalodata: any = {
  "united states": [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  "united kingdom": [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  mexico: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  germany: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  france: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  italy: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  spain: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  japan: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Facebook", value: "Facebook" },
    { label: "Friend's Recommendation", value: "Friend's Recommendation" },
    { label: "Others", value: "Others" },
  ],
  brazil: [
    { label: "Youtube", value: "Youtube" },
    { label: "TikTok", value: "TikTok" },
    { label: "Facebook", value: "Facebook" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  china: [
    { label: "抖音", value: "抖音" },
    { label: "小红书", value: "小红书" },
    { label: "视频号", value: "视频号" },
    { label: "公众号", value: "公众号" },
    { label: "知乎", value: "知乎" },
    { label: "微信社群", value: "微信社群" },
    { label: "Others", value: "Others" },
  ],
  vietnam: [
    { label: "Facebook Kalodata ", value: "Facebook Kalodata" },
    { label: "TikTok Kalodata", value: "TikTok Kalodata" },
    {
      label: "Cộng đồng trên Facebook",
      value: "Cộng đồng trên Facebook",
    },
    { label: "KOL-KOC", value: "KOL-KOC" },
    { label: "Others", value: "Others" },
  ],
  thailand: [
    { label: "Kalodata Official", value: "Kalodata Official" },
    { label: "KOL/KOC", value: "KOL/KOC" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  indonesia: [
    { label: "Kalodata Official", value: "Kalodata Official" },
    { label: "KOL/KOC", value: "KOL/KOC" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  malaysia: [
    { label: "Kalodata Official", value: "Kalodata Official" },
    { label: "KOL/KOC", value: "KOL/KOC" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
  DEFAULT: [
    { label: "Kalodata Official", value: "Kalodata Official" },
    { label: "Referral code channel", value: "Referral code channel" },
    { label: "Others", value: "Others" },
  ],
};

// 没有渠道的国家
export const BizCountry_No_HowKnownKalodata = ["philippines"];

export const USER_BIZ_COUNTRY_MAP: { [key in string]: string } = {
  indonesia: "ID",
  malaysia: "MY",
  thailand: "TH",
  vietnam: "VN",
  philippines: "PH",
  "united states": "US",
  "united kingdom": "GB",
  singapore: "SG",
  mexico: "MX",
  germany: "DE",
  france: "FR",
  italy: "IT",
  spain: "ES",
  japan: "JP",
  brazil: "BR",
  china: "CN",
  australia: "AUD",
  canada: "CAD",
  india: "INR",
};

export const USER_COUNTRY_MAP_BIZ: { [key in string]: string } = {
  ID: "Indonesia",
  MY: "Malaysia",
  TH: "Thailand",
  VN: "Vietnam",
  PH: "Philippines",
  US: "United States",
  GB: "United Kingdom",
  SG: "Singapore",
  MX: "Mexico",
  DE: "Germany",
  FR: "France",
  IT: "Italy",
  ES: "Spain",
  JP: "Japan",
  BR: "Brazil",
  CN: "China",
  AUD: "Australia",
  CAD: "Canada",
  INR: "India",
  CNY: "China",
  KR: "South Korea",
};

export default function useCookieTip() {
  const showCookie =
    window?.KALO_DATA?.reqCountry === "United States" ||
    window?.KALO_DATA?.reqCountry === "United Kingdom" ||
    window?.KALO_DATA?.reqCountry === "Mexico" ||
    window?.KALO_DATA?.reqCountry === "Germany" ||
    window?.KALO_DATA?.reqCountry === "France" ||
    window?.KALO_DATA?.reqCountry === "Italy" ||
    window?.KALO_DATA?.reqCountry === "Spain" ||
    window?.KALO_DATA?.reqCountry === "Brazil" ||
    window?.KALO_DATA?.reqCountry === "Japan";

  return { showCookie };
}

export const SEARCH_TRANSLATE_COUNTRY_LANGUAGE: { [key in string]: string } = {
  US: "en-US",
  GB: "en-US",
  SG: "en-US",
  MY: "en-US",
  PH: "en-US",
  ID: "id-ID",
  TH: "th-TH",
  VN: "vi-VN",
  MX: "es-ES",
  JP: "ja-JP",
  BR: "pt-BR",
};

export const TIKTOK_PRODUCT_LINK_MAP: { [key in string]: string } = {
  US: "https://www.tiktok.com/shop/pdp",
  GB: "https://www.tiktok.com/shop",
  MY: "https://shop.tiktok.com/view/product",
  PH: "https://shop.tiktok.com/view/product",
  ID: "https://shop.tiktok.com/view/product",
  TH: "https://shop.tiktok.com/view/product",
  VN: "https://shop.tiktok.com/view/product",
  SG: "https://shop.tiktok.com/view/product",
  MX: "https://shop.tiktok.com/view/product",
  ES: "https://www.tiktok.com/view/product",
  DE: "https://www.tiktok.com/view/product",
  FR: "https://www.tiktok.com/view/product",
  IT: "https://www.tiktok.com/view/product",
  BR: "https://shop.tiktok.com/view/product",
  JP: "https://shop.tiktok.com/view/product",
};

export const handelTiktokProductLink = (region: string, productId: string, language?: string) => {
  if (["DE", "FR", "IT", "ES"].includes(region)) {
    return `${TIKTOK_PRODUCT_LINK_MAP[region]}` + `/${productId}` + `?region=${region}&locale=${language}`;
  } else if (["GB"].includes(region)) {
    return (
      `${TIKTOK_PRODUCT_LINK_MAP[region]}` +
      `/${region.toLocaleLowerCase()}` +
      `/pdp/${productId}` +
      `?source=product_detail&enter_from=product_detail&enter_method=feed_list_brand_cat&region=${region}`
    );
  } else if (["US"].includes(region)) {
    return `${TIKTOK_PRODUCT_LINK_MAP[region]}/mens-athletic-t-shirt-by-brand-lightweight-quick-dry-crew-neck-tops/${productId}?source=ecommerce_store&region=${region}`;
  } else if (["BR", "PH", "MY", "TH", "VN", "SG", "MX", "JP", "ID"].includes(region)) {
    // https://shop.tiktok.com/view/product/1731794719771887429?region=JP&locale=en&source=agency
    return `${TIKTOK_PRODUCT_LINK_MAP[region]}/${productId}?region=${region}&locale=${language}&source=agency`;
  }
  return `${TIKTOK_PRODUCT_LINK_MAP[region]}/pdp/brielle-tunik-wanita-bahan-shakila-premium-halus-dan-adem/${productId}?source=product_detail&region=${region}`;
};
